import { Component, ElementRef, HostListener, inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
// import { NotificationService } from './services/pushNotification.service';
//  import { SwPush } from '@angular/service-worker';
import { FcmService } from './services/fcm.service';
import { DeviceService } from './services/device.service';
import { ApiService } from './services/api.service';
import { Subscription } from 'rxjs';
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from '@angular/animations';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { RouterOutlet } from '@angular/router';
import { ChatComponent } from './components/chat/chat.component';
import { LoadingComponent } from './components/loading/loading.component';

enum DisplayType {
  Fixed = 'fixed-chat',
  Collapsible = 'collapsible-chat',
}

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, FormsModule, ReactiveFormsModule, NavbarComponent, FooterComponent, ChatComponent],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('rotateAnimation', [
      state('rotated', style({ transform: 'rotate(0deg)' })),
      state('default', style({ transform: 'rotate(-360deg)' })),
      transition('default => rotated', animate('500ms ease-out')),
      transition('rotated => default', animate('500ms ease-out')),
    ]),
    trigger('fadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('150ms ease-in-out', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({ opacity: 1 }),
        animate('150ms ease-in-out', style({ opacity: 0 })),
      ]),
    ]),
  ],
})
export class AppComponent implements OnInit {
  private readonly botIconPath = './assets/images/bot.png';
  private readonly chatIconPath = './assets/images/chat.png';
  public isOpen = false;
  public iconSrc = this.chatIconPath;
  public iconState = 'default';
  public displayType = DisplayType;
  isBrowser = isPlatformBrowser(inject(PLATFORM_ID));
  @ViewChild('chatContainer', { static: false }) chatContainerRef!: ElementRef;
  constructor(
    private metaTagService: Meta,
    private title: Title
  ) {}
  ngOnInit(): void {
    this.title.setTitle('CDIWork | connecting clients and freelancers globally');
    this.metaTagService.addTags([
      {
        name: 'keywords',
        content: 'CDIWork, Ethiopia freelancing, remote jobs in ethiopia',
      },
    ]);
    this.metaTagService.addTags([
      {
        name: 'description',
        content:
          'CDIWork is a platform connecting clients and freelancers globally. Hire experts, find work, and collaborate on digital projects.',
      },
    ]);
  }

  onChangeChatState() {
    this.isOpen = !this.isOpen;
    this.iconState = this.iconState === 'default' ? 'rotated' : 'default';
    if (this.isOpen) this.iconSrc = this.chatIconPath;
    else this.iconSrc = this.botIconPath;
  }
  // @HostListener('document:click', ['$event'])
  // handleClickOutside(event: MouseEvent) {
  //   console.log('clicked');
    
  //   // Check if the click is inside the chat container
  //   const targetElement = event.target as HTMLElement;

  //   // Close chat only if the click is outside the chat container
  //   if (this.isOpen && this.chatContainerRef && !this.chatContainerRef.nativeElement.contains(targetElement)) {
  //     console.log('close');
  //     this.isOpen = false;
  //     this.iconState = 'default';
  //     this.iconSrc = this.botIconPath;
  //   }
  // }

  // // Prevent click propagation inside chat container to avoid closing when clicking inside
  // @HostListener('click', ['$event'])
  // stopClickPropagation(event: MouseEvent) {
  //   event.stopPropagation();
  // }
}
